import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {MaterialModule} from '../../../../material.module';
import {environment} from '../../../../../environments/environment';
import {Marked} from 'marked';
import {ContentInterpreterService} from '../../../../services/content-interpreter.service';
import {ScheduledTask} from '../../../../models/scheduled-task.model';
import {WorkflowsService} from "../../../../services/objects/workflows.service";
import {ToastService} from "../../../../services/layout/toast.service";

@Component({
  selector: 'app-workflow-previous-runs',
  templateUrl: './workflow-previous-runs.component.html',
  styleUrls: ['./workflow-previous-runs.component.scss'],
    imports: [MaterialModule, ReactiveFormsModule, FormsModule, DatePipe],
  providers: [Marked],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowPreviousRunsComponent implements OnInit {
    marked = inject(Marked);
    private contentInterpreter = inject(ContentInterpreterService);
    private workflowService = inject(WorkflowsService);
    private toastService = inject(ToastService);

  @Input() allTasks!: ScheduledTask[];
  @Input() workflowOptions: any;
  expandedElement: ScheduledTask | null = null;
  displayedColumns: string[] = ['id', 'clientId', 'description', 'created', 'completedSuccessfully'];
  protected readonly environment = environment;

  ngOnInit(): void {}

  parseJsonOutput(output: any): any {
    if (!output?.base64Data || !output.contentType) return null;
    return this.contentInterpreter.interpretContent(output.contentType, output.base64Data);
  }

  getStepColumnName(parsed: any, index: number): string {
    const stepResult = parsed?.[0]?.Steps?.[index]?.Result;
    return stepResult ? `step${index}_${Object.keys(stepResult)[0]}` : '';
  }

  getStepName(parsed: any, index: number): string {
    return parsed?.[0]?.Steps?.[index]?.Result ? Object.keys(parsed[0].Steps[index].Result)[0] : '';
  }

  getStepColumns(parsed: any): string[] {
    if (!parsed || !parsed[0]) return [];
    const columns = ['url'];
    parsed[0].Steps?.forEach((step: any, i: number) => {
      const stepName = step?.Result ? Object.keys(step.Result)[0] : '';
      if (stepName) {
        columns.push(`step${i}_${stepName}`);
      }
    });
    return columns;
  }

  trackByTask(index: number, task: ScheduledTask): any {
    return task.id;
  }

  protected readonly console = console;

  detailRow(task: any) {
    console.log('task', task);
    this.expandedElement = this.expandedElement === task ? null : task;
    console.log('task', task);
  }

  downloadExcel(output: any) {
    this.workflowService.downloadExcelFileForWorkflowAsync(output).subscribe((file: Blob) => {
      const fileName = `${this.workflowOptions?.name ?? "error"}.xlsx`;
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(file);
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
      this.toastService.showSuccess('Excel file downloaded successfully.', 3000);
    }, error => {
      console.error('Error downloading Excel file', error);
      this.toastService.showError('Error downloading Excel file.', 3000);
    });
  }
}